import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, Subscription, EMPTY } from 'rxjs';
import { BalancesServiceDefinition } from './../../models/balances/index';
import { TradingServiceDefinition } from './../../models/common/trading-service-definition';
import { DomainContext, ServiceRouter, LogService } from '@pershing/pershing-core';
import { catchError } from 'rxjs/operators';
import { BalancesConstants } from './../../utils/balances/balances-constants';
/**
 * @desc interacts with the backend services to fetch the data and updates the balancesSummary$
 *
 */

const acctNumParam = 'urn:id:headers.x-AccountNumber';

@Injectable()
export class BalancesService {
    private baseUrl: string;
    private platform: string = '';
    context: DomainContext<any>;
    contextSubscription: Subscription;
    errorSubscription: Subscription;
    httpSubscription: Subscription;
    //this variable should be false when Balances is back to new API calls
    isNDSHoldingsBalancesAPI: boolean = false;
   
    private getHttpHeadersWithAcctNum(acctNum: string) {
        return new HttpHeaders({
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'x-AccountNumber': acctNum
        });

    }

    constructor(private logService: LogService, private http: HttpClient, private serviceRouter: ServiceRouter, @Optional() @Inject('AppSettings') appSettings: any) {
        if (appSettings?.platform) {
            this.platform = appSettings.platform;
        } else {
            this.platform = 'professional';
        }
        if(this.isNDSHoldingsBalancesAPI){
            this.baseUrl = this.serviceRouter.getServiceRouteURL(TradingServiceDefinition.getInstance(this.platform), { ignoreOptions: { serviceVersion: true } });
        }else{
            this.baseUrl = this.serviceRouter.getServiceRouteURL(BalancesServiceDefinition.getInstance(this.platform), { ignoreOptions: { serviceVersion: true } });
        }
    }

    getBalances(acctNum: string, quoteType?: string): Observable<any> {
        if(this.isNDSHoldingsBalancesAPI){
            quoteType = quoteType ? quoteType : BalancesConstants.DELAYED;
            let url = this.baseUrl + '/' + acctNumParam + '/' + 'balances' + '?quoteType=' + quoteType;
            return this.http.get(url, { headers: this.getHttpHeadersWithAcctNum(acctNum), observe: 'response' })
            .pipe(catchError((error: any) => {
                this.handleBalancesError(error);
                return EMPTY; // stream should continue hence return an empty observable
            }));
        }else{
            let url = BalancesServiceDefinition.getBalancesResourceURL(this.baseUrl, 'account', acctNum, quoteType);
            return this.http.get(url, { observe: 'response' })
            .pipe(catchError((error: any) => {
                this.handleBalancesError(error);
                return EMPTY; // stream should continue hence return an empty observable
            }));
        }
        
    }

    private handleBalancesError(error: HttpErrorResponse): void {
        if (error) {
            this.logService.error(error);
        }
    }
}
